import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Phone, Instagram, Mail, MapPin, Clock, ChevronRight, Home as HomeIcon } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast, Toaster } from 'sonner';
import axios from 'axios';
import '../styles/demandedevis.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const DemandeDevis = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    typeEvenement: '',
    lieuEvenement: '',
    nombrePizza: '',
    telephone: '',
    email: '',
    dateEvenement: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${BACKEND_URL}/api/devis`, formData);
      // Rediriger vers la page de remerciement
      navigate('/merci');
    } catch (error) {
      console.error('Erreur lors de l\'envoi du devis:', error);
      toast.error('Erreur lors de l\'envoi de votre demande. Veuillez réessayer.', {
        duration: 5000,
      });
    }
  };

  return (
    <div className="demandedevis-container">
      <Toaster position="top-right" richColors />
      
      {/* Header */}
      <header className="demandedevis-header">
        <div className="demandedevis-nav">
          <div className="demandedevis-logo-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_49df62c5-2f2b-4015-9d48-0abd42138eec/artifacts/jxvxk1uq_file_00000000b8f0720a897da348f1691752.png" 
              alt="Pizza Mamma Logo" 
              className="demandedevis-logo"
            />
            <div className="demandedevis-brand-name">
              <span className="brand-pizza">PIZZA</span>
              <span className="brand-mamma">MAMMA</span>
            </div>
          </div>
          <Button onClick={() => navigate('/')} className="btn-home-nav">
            <HomeIcon size={20} className="mr-2" />
            Retour à l'accueil
          </Button>
        </div>
      </header>

      {/* Main Content */}
      <main className="demandedevis-main">
        <div className="demandedevis-content">
          <div className="demandedevis-intro">
            <h1 className="demandedevis-title">Demande de Devis</h1>
            <p className="demandedevis-subtitle">
              Remplissez le formulaire ci-dessous et nous vous recontacterons rapidement 
              pour discuter de votre événement et vous proposer un devis personnalisé.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="demandedevis-form">
            <div className="form-row">
              <div className="form-group">
                <Label htmlFor="nom">Nom *</Label>
                <Input
                  id="nom"
                  name="nom"
                  value={formData.nom}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <Label htmlFor="prenom">Prénom *</Label>
                <Input
                  id="prenom"
                  name="prenom"
                  value={formData.prenom}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <Label htmlFor="typeEvenement">Type d'événement *</Label>
                <Input
                  id="typeEvenement"
                  name="typeEvenement"
                  value={formData.typeEvenement}
                  onChange={handleInputChange}
                  placeholder="Ex: Mariage, Anniversaire, Festival..."
                  required
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <Label htmlFor="dateEvenement">Date de l'événement *</Label>
                <Input
                  id="dateEvenement"
                  name="dateEvenement"
                  type="date"
                  value={formData.dateEvenement}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <Label htmlFor="lieuEvenement">Lieu de l'événement *</Label>
                <Input
                  id="lieuEvenement"
                  name="lieuEvenement"
                  value={formData.lieuEvenement}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <Label htmlFor="nombrePizza">Nombre de pizza ou formule *</Label>
                <Input
                  id="nombrePizza"
                  name="nombrePizza"
                  value={formData.nombrePizza}
                  onChange={handleInputChange}
                  placeholder="Ex: 50 pizzas, Formule complète..."
                  required
                  className="form-input"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <Label htmlFor="telephone">Numéro de téléphone *</Label>
                <Input
                  id="telephone"
                  name="telephone"
                  type="tel"
                  value={formData.telephone}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <Label htmlFor="email">Email *</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                />
              </div>
            </div>

            <Button type="submit" className="btn-submit">
              Envoyer la demande
              <ChevronRight className="ml-2" size={20} />
            </Button>
          </form>

          {/* Contact Info */}
          <div className="demandedevis-contact-info">
            <h3>Besoin d'aide pour remplir le formulaire ?</h3>
            <div className="contact-methods">
              <a href="tel:0613658698" className="contact-method">
                <Phone size={18} />
                <span>06 13 65 86 98</span>
              </a>
              <a href="https://wa.me/33613658698" target="_blank" rel="noopener noreferrer" className="contact-method whatsapp">
                <Phone size={18} />
                <span>WhatsApp</span>
              </a>
              <a href="mailto:maarekpaul@gmail.com" className="contact-method">
                <Mail size={18} />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="demandedevis-footer">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-info">
              <MapPin size={16} />
              <span>Place des Alizés, Créteil</span>
            </div>
            <div className="footer-info">
              <Clock size={16} />
              <span>Tous les soirs (sauf vendredi) · 18h - 22h</span>
            </div>
          </div>
          <div className="footer-section">
            <a href="https://instagram.com/pizzamamma94" target="_blank" rel="noopener noreferrer" className="footer-link">
              <Instagram size={16} />
              <span>@pizzamamma94</span>
            </a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 Pizza Mamma - L'authenticité italienne à Créteil</p>
        </div>
      </footer>
    </div>
  );
};

export default DemandeDevis;
